import { func, number } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import withConfirm from '../../../../generic/with-confirm';
import { COLORS } from '../../../../utils/constants';
import { allStatusesEnum as invoiceStatuses } from '../../../constants';

const ButtonWithConfirmation = withConfirm(
  'Do you really want to cancel this invoice?',
)(Button);

export default function CancelButton({ onUpdateStatus, id, ...rest }) {
  return (
    <ButtonWithConfirmation
      onClick={() => onUpdateStatus(id, invoiceStatuses.CANCELED.value)}
      color={COLORS.DANGER}
      {...rest}
    >
      Cancel
    </ButtonWithConfirmation>
  );
}

CancelButton.propTypes = {
  onUpdateStatus: func.isRequired,
  id: number.isRequired,
};
